export const CREATE_UPDATE_SHAPE = "CREATE_UPDATE_SHAPE";
export const REMOVE_ALL_SHAPES = "REMOVE_ALL_SHAPES";
export const SELECT_SHAPE = "SELECT_SHAPE";
export const SELECT_SHAPE_FEED_ID = "SELECT_SHAPE_FEED_ID";
